import type { IStringifyOptions } from 'qs';
import qs from 'qs';

export const parseParams = (search: string, options: Omit<IStringifyOptions, 'ignoreQueryPrefix'> = {}) =>
  qs.parse(search, { ignoreQueryPrefix: true, ...options });
